<div class="row p-b-10">
	<div class="col-sm-12">
		<h4 class="page-title">{{TR "Bedienung"}}</h4>
	</div>
</div>
{{> WARNING_HINTS}}
{{#unless decreasedUsability}}
<div class="row">
	{{#each temperatures}}
	{{#COMPARE this.name '!==' 'Raumtemperatur'}}
	{{#COMPARE this.name '!==' 'Solltemperatur'}}
	<div class="col-xs-12 col-sm-6 col-lg-4">
		<div id="h-{{@index}}" class="js-same-height card-box widget-box-1 {{#if ../inconsistentRegisters}}highlight{{else}}bg-white{{/if}}">
			<div class="card-box-header button-height">
				{{#if canEdit}}
					<button id="js-{{@index}}" class="js-temperature btn btn-white pull-right">
						<i class="{{#if ../inconsistentRegisters}}fa fa-hourglass{{else}}glyphicon glyphicon-pencil{{/if}}"></i>
					</button>
				{{/if}}
				<h4 class="text-dark">{{TR name}}</h4>
			</div>
			<h2 id="ct-temp-{{@index}}" class="text-custom text-center">
				{{#COMPARE data '!=' 32767}}{{FIXED_POINT data 1}}{{else}}--{{/COMPARE}} °C
			</h2>
			{{#unless ../is_holiday}}
			{{#COMPARE this.name '===' 'Raumtemperatur'}}
			{{#if ../activationDate}}
			<p>
				<span class="text-muted">{{TR "Aktiv bis:"}}</span>
				<span class="text-dark pull-right">{{../activationDate}}</span>
			</p>
			{{else}}
			{{#COMPARE ../chosenModeSetting.color '!==' 'auto'}}
			<p>
				<span class="text-muted">{{TR "Aktiv bis:"}}</span>
				<span class="text-dark pull-right">{{TR "Regler Neustart"}}</span>
			</p>
			{{/COMPARE}}
			{{/if}}
			{{/COMPARE}}
			{{/unless}}
		</div>
	</div>
	{{/COMPARE}}
	{{/COMPARE}}
	{{/each}}
	<div class="col-xs-12 col-sm-6 col-lg-4">
		<div id="h-betriebsart" class="js-same-height card-box widget-box-1 {{#if inconsistentRegisters}}highlight{{else}}bg-white{{/if}}">
			<div class="card-box-header button-height">
				{{#if showBtnOpMode}}
					<button id="js-betriebsart" class="btn btn-white pull-right">
						<i class="{{#if inconsistentRegisters}}fa fa-hourglass{{else}}glyphicon glyphicon-pencil{{/if}}"></i>
					</button>
				{{/if}}
				<h4 class="text-dark">{{TR "Betriebsart"}}</h4>
			</div>
			<h2 id="ct-mode" class="text-custom text-center">
				{{#if is_holiday}}
					<i class="{{modeConfigs.holiday.icon}} text-{{modeConfigs.holiday.color}}"></i> {{modeConfigs.holiday.text}}
				{{else}}
					{{#if extendedView}}
						<i id="ct-adjusted-mode" class="{{chosenModeSetting.icon}} text-{{chosenModeSetting.color}}"></i>
						<i class="{{activeModeSetting.icon}} text-{{activeModeSetting.color}}"></i>
					{{else}}
						<i class="{{computedModeSetting.icon}} text-{{computedModeSetting.color}}"></i> {{computedModeSetting.text}}
					{{/if}}
				{{/if}}
			</h2>
			{{#if activationDate}}
			<p>
				<span class="text-muted">{{TR "Aktiv bis:"}}</span>
				<span class="text-dark pull-right">{{activationDate}}</span>
			</p>
			{{else}}
			{{#COMPARE chosenModeSetting.color '!==' 'auto'}}
			<p>
				<span class="text-muted">{{TR "Aktiv bis:"}}</span>
				<span class="text-dark pull-right">{{TR "Regler Neustart"}}</span>
			</p>
			{{/COMPARE}}
			{{/if}}
		</div>
	</div>
</div>
{{/unless}}

<div class="row">
	{{#each timePrograms}}
	<div class="col-xs-12 col-lg-6">
		<div id="h-timeprogram-{{@index}}" class="card-box widget-box-1 {{#if inconsistent}}highlight{{else}}bg-white{{/if}}">
			<div class="card-box-header button-height">
				{{#if inconsistent}}
				<button id="js-timeprogram-{{@index}}" class="js-edit-timeprogram btn btn-white pull-right">
				<i class="fa fa-hourglass"></i>
				</button>
				{{else}}
					{{#unless ../readOnly}}
					<button id="js-timeprogram-{{@index}}" class="js-edit-timeprogram btn btn-white pull-right">
					<i class="glyphicon glyphicon-pencil"></i>
					</button>
					{{/unless}}
				{{/if}}
				<h4 class="text-dark">{{TR name}}</h4>
			</div>
			{{#unless inconsistent}}
			{{#each this.timelines}}
				<div class="row">
					<div class="col-xs-12 col-sm-2 p-t-20 p-r-0">
						<h4>{{this.label}}</h4>
					</div>
					<div class="col-xs-12 col-sm-10">
						<div class="svg-container">
							<svg  id="svg-{{this.ID}}"
								xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
								xmlns="http://www.w3.org/2000/svg" version="1.1"
								viewBox="0 15 400 40" width='100%' height="100%" >
									<line x1="8" y1="50" x2="392" y2="50" stroke="rgb(222,222,222)" stroke-width="8"/>
							</svg>
						</div>
					</div>
				</div>
			{{/each}}
			{{/unless}}
		</div>
	</div>
	{{/each}}
</div>
